import { useTaskListContext } from '@app/providers/TaskListProvider';

// Narrow task-actions facade for LeadCard.
// LeadCard only needs to create a task for a lead, preview a task, close the
// task modal, and register a refresh callback — not the full task
// registry/calendar state. This adapter is the single point that reads
// `TaskListProvider`, so the provider can later be narrowed or replaced (e.g. a
// dedicated `TaskActionsProvider`) without touching the LeadCard hooks.
export const useTaskActions = () => {
  const {
    createTaskForLead,
    openPreviewTaskModal,
    closeTaskDetailsModal,
    onChangeSuccess,
  } = useTaskListContext();

  return {
    createTaskForLead,
    openPreviewTaskModal,
    closeTaskDetailsModal,
    onChangeSuccess,
  };
};
